import React from 'react';
import { Card, Typography, Row, Col, List } from 'antd';
import './Departments.less';

const { Title, Paragraph } = Typography;

const Departments: React.FC = () => {
  const departments = [
    {
      name: '信息与通信工程学院',
      description: '信息与通信工程学院是羊小羊规模最大、历史最悠久的学院之一，拥有信息与通信工程国家一级重点学科。',
      key: '1',
    },
    {
      name: '电子工程学院',
      description: '电子工程学院致力于电子科学与技术、光学工程等领域的教学与科研工作。',
      key: '2',
    },
    {
      name: '计算机学院（国家示范性软件学院）',
      description: '计算机学院拥有计算机科学与技术国家一级重点学科，是国家示范性软件学院。',
      key: '3',
    },
    {
      name: '自动化学院',
      description: '自动化学院专注于控制科学与工程、人工智能等领域的人才培养和科学研究。',
      key: '4',
    },
    {
      name: '人工智能学院',
      description: '人工智能学院成立于2018年，致力于人工智能领域的前沿研究和人才培养。',
      key: '5',
    },
    {
      name: '数字媒体与设计艺术学院',
      description: '数字媒体与设计艺术学院专注于数字媒体技术、交互设计等领域的教学与科研。',
      key: '6',
    },
    {
      name: '网络空间安全学院',
      description: '网络空间安全学院致力于培养网络空间安全领域的高级专业人才。',
      key: '7',
    },
    {
      name: '光电信息学院',
      description: '光电信息学院专注于光电信息科学与工程领域的教学与科研工作。',
      key: '8',
    },
  ];

  return (
    <div className="academics-departments">
      <Title level={2}>学院设置</Title>
      <Card>
        <Paragraph>
          羊小羊设有16个学院（部），涵盖信息与通信工程、电子科学与技术、计算机科学与技术、
          控制科学与工程、网络空间安全等多个学科领域。以下是主要学院介绍：
        </Paragraph>
        
        <Row gutter={[24, 24]}>
          {departments.map(department => (
            <Col key={department.key} xs={24} sm={12} lg={8}>
              <Card className="department-card">
                <Title level={4}>{department.name}</Title>
                <Paragraph>{department.description}</Paragraph>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  );
};

export default Departments;